import { obtenerToken, cerrarSesion } from "./sesion";

// Envoltura de fetch() para los endpoints del cajero: agrega automaticamente
// el token de sesion (como campo "token" en el body, o como ?token= en la
// URL si no hay body) y, si el servidor responde 401 (sesion invalida o
// expirada), limpia la sesion y manda de vuelta al login. Evita tener que
// agregar el token a mano en cada punto donde se llama fetch().
export async function apiFetch(url, options = {}) {
  const token = obtenerToken();
  let { body } = options;
  let urlFinal = url;

  if (body instanceof FormData) {
    body.append("token", token || "");
  } else if (typeof body === "string") {
    try {
      const datos = JSON.parse(body);
      datos.token = token;
      body = JSON.stringify(datos);
    } catch (error) {
      // El body no era JSON; se deja igual y el token viaja por la URL.
      urlFinal += (urlFinal.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(token || "");
    }
  } else if (!body) {
    urlFinal += (urlFinal.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(token || "");
  }

  const respuesta = await fetch(urlFinal, { ...options, body });

  if (respuesta.status === 401) {
    cerrarSesion();
    window.location.assign("/");
  }

  return respuesta;
}
